import React, { useState } from "react";
import { Package, Truck, ShoppingBag } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { ShopOrdersPanel, SupplierOrdersPanel, ShopProductsPanel } from "@/components/admin/ShopPanels";

// Groomer (shop) boutique view: orders + supplier orders + availability-only products
export const ShopAdmin = () => {
  const { t } = useLang();
  const s = t.ashop;
  const [tab, setTab] = useState("orders");

  const TABS = [
    { id: "orders", label: s.tab_orders, icon: ShoppingBag },
    { id: "suppliers", label: s.supplier_orders_title, icon: Truck },
    { id: "products", label: s.tab_products, icon: Package },
  ];

  return (
    <div data-testid="groomer-shop">
      <div className="flex gap-2 overflow-x-auto pb-1 mb-5" data-testid="groomer-shop-tabs">
        {TABS.map((tb) => (
          <button
            key={tb.id}
            onClick={() => setTab(tb.id)}
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold whitespace-nowrap transition-colors no-a11y-underline ${
              tab === tb.id ? "bg-brand text-brand-cream" : "bg-white text-brand-ink/70 border border-brand/10 hover:bg-brand-soft/50"
            }`}
            data-testid={`groomer-shop-tab-${tb.id}`}
          >
            <tb.icon className="h-4 w-4" /> {tb.label}
          </button>
        ))}
      </div>
      {tab === "orders" && <ShopOrdersPanel />}
      {tab === "suppliers" && <SupplierOrdersPanel />}
      {tab === "products" && <ShopProductsPanel devMode={false} />}
    </div>
  );
};

export default ShopAdmin;
